import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import Layout from '../components/Layout';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import DashboardPage from '../pages/DashboardPage';
import ProfilePage from '../pages/ProfilePage';

// Route configuration as JSON-like structure
const routeConfig = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'login',
        element: <LoginPage />,
        protected: false,
      },
      {
        path: 'register', 
        element: <RegisterPage />,
        protected: false,
      },
      {
        path: 'dashboard',
        element: <DashboardPage />,
        protected: true,
      },
      // Future routes can be added here
      {
        path: 'profile',
        element: <ProfilePage />,
        protected: true,
      },
      {
        path: 'workouts',
        element: <div>Workouts Page (Coming Soon)</div>,
        protected: true,
      },
      {
        path: 'exercises',
        element: <div>Exercises Page (Coming Soon)</div>,
        protected: true,
      },
      {
        path: 'progress',
        element: <div>Progress Page (Coming Soon)</div>,
        protected: true,
      },
    ],
  },
];

// Function to map route config to React Router routes
const mapRoutes = (routes) => {
  return routes.map((route) => {
    const { children, ...routeProps } = route;
    
    if (children) {
      return {
        ...routeProps,
        children: children.map((child) => {
          const { protected: isProtected, element, ...childProps } = child;
          
          return {
            ...childProps,
            element: isProtected ? (
              <ProtectedRoute>{element}</ProtectedRoute>
            ) : element,
          };
        }),
      };
    }
    
    const { protected: isProtected, element, ...rest } = routeProps;
    return {
      ...rest,
      element: isProtected ? (
        <ProtectedRoute>{element}</ProtectedRoute>
      ) : element,
    };
  });
};

// Create the router with mapped routes
const router = createBrowserRouter(mapRoutes(routeConfig));

export default router;
export { routeConfig };
